export default "__VITE_ASSET__DWt6zYYW__"